export default {
  theme: { light: 'Helles Thema', dark: 'Dunkles Thema' },
  login: {
    textCredenciais: 'Geben Sie Ihre Anmeldedaten ein',
    acessLogin: 'Benutzer',
    acessPassword: 'Passwort',
    lembrarSenha: 'Benutzername und Passwort merken',
    forgotPass: 'Ich habe mein Passwort vergessen',
    Enter: 'Anmelden',
    escolhaApelido: 'Wähle deinen Spitznamen',
    descApelido: 'Um fortzufahren, lege einen Anzeigenamen fest.'
  },
  registro: {
    titleRegister: 'Registrieren',
    labelUsuario: 'Benutzer',
    ruleUsuarioRequired: 'Benutzer ist erforderlich',
    labelApelido: 'Spitzname',
    ruleApelidoRequired: 'Spitzname ist erforderlich',
    labelEmail: 'E-Mail',
    ruleEmailRequired: 'E-Mail ist erforderlich',
    ruleEmailInvalid: 'Ungültige E-Mail',
    labelSenha: 'Passwort',
    ruleSenhaRequired: 'Passwort ist erforderlich',
    ruleSenhaMin: 'Mindestens 8 Zeichen',
    ruleSenhaLetter: 'Verwenden Sie mindestens einen Buchstaben',
    ruleSenhaNumber: 'Verwenden Sie mindestens eine Zahl',
    ruleSenhaSymbol: 'Verwenden Sie mindestens ein Symbol',
    strengthFraca: 'Schwach',
    strengthMedia: 'Mittel',
    strengthForte: 'Stark',
    labelRepeatPassword: 'Passwort wiederholen',
    ruleConfirmationRequired: 'Bestätigung ist erforderlich',
    rulePasswordsMatch: 'Passwörter stimmen nicht überein',
    btnRegister: 'Registrieren',
    alertSuccess: 'Ausstehendes Konto erstellt! Überprüfen Sie Ihren Bestätigungscode.'
  },
  download: {
    title: 'Laden Sie jetzt unseren Client herunter',
    btnDownload: 'Herunterladen'
  },
  characters: {
    title: 'Meine Charaktere',
    youHave: 'Sie haben {count} Charakter(e).',
    noCharacters: 'Sie besitzen keine Charaktere.',
    classLabel: 'Klasse:',
    levelLabel: 'Level:',
    goldLabel: 'Gold:',
    silverLabel: 'Silber:',
    bronzeLabel: 'Bronze:',
    createdLabel: 'Erstellt:',
    rebirthsLabel: 'Wiedergeburten:',
    bannedLabel: 'Gesperrt:',
    yes: 'Ja',
    no: 'Nein'
  },
  menu: {
    home: 'Startseite',
    login: 'Anmelden',
    register: 'Registrieren',
    download: 'Download',
    discord: 'Discord',
    info: 'Meine Charaktere',
    changePassword: 'Informationen ändern',
    inbox: 'Posteingang (in Entwicklung)',
    market: 'Zephyr-Shop',
    coinsBr: 'Zephyr Coins Brasilien',
    coinsInt: 'Zephyr Coins International',
    wikia: 'Zephyr Wikia',
    ranked: 'Rangliste',
    alquimia: 'Alchemie erstellen',
    atts: 'Aktualisierungsnotizen',
    roulette: 'Glücksrad',
    daily: 'Tägliche Sammlung',
    casino: 'Zephyr-Casino (in Entwicklung)',
    escala: 'Zephyr-Skala',
    logout: 'Abmelden',
    loggedAs: 'Angemeldet als',
    servicos: 'Dienste'
  },
  snackbar: {
    newMessages: 'Sie haben {count} neue Nachricht(en)!'
  },
  footer: {
    copy: '{site} - Alle Rechte vorbehalten'
  },
  hero: {
    title: 'Grand Fantasia Zephyr',
    subtitle: 'der beste private Grand Fantasia Server'
  },
  chat: {
    greeting: 'Hallo! Wir freuen uns auf dich, besuche unseren Discord!'
  },
  ranks: {
    title: 'HIGHLIGHTS',
    currentMonth: 'Monat: {month}',
    deaths: 'Top Tode',
    crystalDamage: 'Top Kristallschaden',
    heal: 'Top Heilung',
    playerDamage: 'Top Spielerschaden',
    wins: 'Top Siege',
    noData: '— keine Daten'
  },
  changeCreds: {
    greeting1: 'Es scheint, dass Sie sich nicht ganz sicher sind, haha...',
    greeting2: 'Sie können Ihre Anmeldedaten ändern',
    newEmail: {
      label: 'Neue E-Mail (!)',
      hint: 'Sie müssen die E-Mail nicht ändern; tun Sie es, wenn Sie möchten.'
    },
    currentPassword: { label: 'Aktuelles Passwort' },
    newPassword: { label: 'Neues Passwort' },
    confirmPassword: { label: 'Neues Passwort wiederholen' },
    updateButton: 'Aktualisieren',
    emailConfirmModal: {
      title: 'Bestätigen Sie Ihre E-Mail',
      emailField: { label: 'Geben Sie Ihre aktuelle E-Mail ein' },
      cancelButton: 'Abbrechen',
      confirmButton: 'Bestätigen'
    },
    validation: {
      emailInvalid: 'Ungültiges E-Mail-Format',
      emailRequired: 'E-Mail ist erforderlich'
    },
    error: {
      noChange: 'Sie können nur fortfahren, wenn Sie E-Mail oder Passwort ändern.',
      fillPassword: 'Bitte füllen Sie alle Passwortfelder aus.',
      passwordMismatch: 'Neue Passwörter stimmen nicht überein.',
      passwordLength: 'Neues Passwort muss mindestens 8 Zeichen haben.'
    },
    success: {
      changeCreds: 'Anmeldedaten erfolgreich aktualisiert!'
    }
  },
  inbox: {
    title: 'Posteingang ({count} offene Anfragen)',
    loginRequired: 'Sie müssen angemeldet sein, um Ihre Nachrichten zu sehen.',
    from: 'von {sender}',
    gold: '{amount} Gold 🟨',
    silver: '{amount} Silber ⚪',
    bronze: '{amount} Bronze 🟤',
    item: 'Gegenstand: {name}'
  },
  wiki: {
    searchPlaceholder: 'Geben Sie ein, um nach einem Gegenstand zu suchen…',
    loading: 'Laden…',
    itemIconAlt: 'Symbol des Gegenstands {name}',
    setItemsTitle: 'Set-Gegenstände',
    setBonusesTitle: 'Set-Boni',
    recipeTitle: 'Herstellungsrezept',
    recipeQty: 'Anzahl: {qty}',
    obtainTitle: 'Wie kann es erhalten werden',
    closeButton: 'Schließen'
  },
  rank: {
    selectGroupLabel: 'Gruppierung auswählen',
    none: '— keine —',
    loading: 'Laden...',
    position: 'Position',
    name: 'Name',
    level: 'Level',
    class: 'Klasse',
    rebirth: 'Wiedergeburt',
    reincarnated: 'Wiedergeboren',
    notReincarnated: 'Nicht wiedergeboren',
    ranks: {
      deaths: 'Sterberang',
      crystalDamage: 'Kristallschadenrang',
      heal: 'Heilungrang',
      playerDamage: 'Spielerschadenrang',
      wins: 'Sieg-Rang'
    },
    stat: {
      deaths: 'Tode',
      crystalDamage: 'Kristallschaden',
      heal: 'Heilung',
      playerDamage: 'Spielerschaden',
      wins: 'Siege'
    }
  },
  alchemy: {
    title: 'Hallo! Willkommen, geben Sie Ihren Alchemievorschlag ab',
    alt: 'Alchemiebild',
    roundLabel: 'Runde {n}:',
    itemPlaceholder: 'Gegenstands-ID {n}',
    sendButton: 'Vorschlag an Discord senden',
    loginError: 'Sie müssen angemeldet sein.',
    successMessage: 'Vorschlag erfolgreich gesendet!',
    sendError: 'Fehler beim Senden des Vorschlags.',
    inserirLote: 'Stapel einfügen',
    idItem: 'Geben Sie die Gegenstands-ID ein',
    regras: {
      title: 'Regeln!',
      forbiddenIntro: 'Nicht erlaubt:',
      forbiddenItems:
        'Verbrauchsgegenstände der Insel, Turmsteine oder Kaos-Ausrüstung, Tarot und spezielle Invasionsdrops wie Emissärkern, Ausrüstung (Set, Waffe, Ring und Umhang) jeglicher Art, exklusive Alchemie-S-Top-RW-Gegenstände und Gegenstände, die vor weniger als 2 Monaten veröffentlicht wurden, NT-Gegenstände in der letzten Runde',
      conclusion: 'Alle Alchemien werden überprüft; im Falle eines Regelverstoßes werden sie nicht validiert.'
    }
  },
  escala: {
    title: 'Preisskala',
    subtitle: 'Preisskala für {currentMonthName} – Schließungsfrist: {timeRemaining}',
    spent: 'Sie haben {spentPoints} Punkte ausgegeben',
    chooseYourRescue: 'Wählen Sie Ihre Belohnung',
    btnExtraEligible: 'Sie haben Rang-Gegenstände zum Einlösen',
    redeemed: 'Eingelöst',
    redeem: 'Einlösen',
    bundlePackage: 'Paket mit Gegenständen:',
    noDescription: '[Keine Beschreibung]',
    topDonorsTitle: 'Unsere Top 10 Spender des Monats',
    columnPlayer: 'Spieler',
    columnSpent: 'Ausgaben',
    extraRewardsTitle: 'Zusätzliche Belohnungen für unsere besten Spender',
    youAre: 'Sie sind auf Platz {rank}!',
    availablePrizes: 'Verfügbare Preise:',
    availablePrize: 'Verfügbarer Preis:',
    clayX: 'Lehm ×{quantity}',
    surpriseGMClick: 'GM-Überraschung (zum Auswählen klicken)',
    instruction:
      'Die obigen Gegenstände sind zusätzliche Belohnungen für unsere besten Spender. Nehmen Sie unbedingt teil.',
    cancel: 'Abbrechen',
    redeemSurprise: 'Einlösen',
    chooseYourSurprise: 'GM-Überraschung: Wählen Sie Ihren Gegenstand',
    chooseYourExtraSurprise: 'GM-Überraschung (Extra-Belohnung): Wählen Sie Ihren Gegenstand',
    rescueExtraTitle: 'Einlösen der Extra-Belohnung'
  },
  service: {
    title: 'Dienst anfordern',
    selectServiceLabel: 'Dienst auswählen',
    options: {
      changeCharacterName: 'Charakternamen ändern',
      recoverItem: 'Gegenstand wiederherstellen',
      changeGuildName: 'Gildennamen ändern',
      recoverDeletedChar: 'Charakter wiederherstellen'
    },
    selectCharLabel: 'Charakter auswählen',
    newCharacterNameLabel: 'Neuer Charaktername',
    lostItemIdLabel: 'Verlorene Gegenstands-ID',
    newGuildNameLabel: 'Neuer Gildenname',
    deletedCharNameLabel: 'Gelöschter Charaktername',
    buttonRequest: 'Anfordern',
    errors: {
      notAuthenticated: 'Benutzer nicht authentifiziert.',
      selectCharAndName: 'Wählen Sie einen Charakter und geben Sie den neuen Namen an.',
      informItemId: 'Geben Sie die Gegenstands-ID an.',
      informNewGuildName: 'Geben Sie den neuen Gildennamen an.',
      informDeletedCharName: 'Geben Sie den Namen des gelöschten Charakters an.'
    },
    success: 'Anfrage erfolgreich gesendet!'
  },
  zephyr: {
    title: 'Acquiriere Zephyr-Punkte (Kauf mit brasilianischer Währung)',
    labelAmountReal: 'Betrag in Reais',
    willReceive: 'Sie erhalten:',
    coins: 'Zephyr-Münzen',
    buttonBuy: 'Erwerben',
    errorPositive: 'Bitte geben Sie einen Wert größer als Null ein.',
    errorPayment: 'Zahlung konnte nicht gestartet werden. Versuchen Sie es erneut.',
    docTitle: 'Grand Fantasia Zephyr'
  },
  acquire: {
    title: 'Erworben mit internationaler Währung',
    labelValueReal: 'Betrag in Reais',
    receive: 'Sie erhalten:',
    coins: 'Zephyr-Münzen',
    approxUSD: 'Ungefähr {usd} USD',
    sendOrderButton: 'Bestellung senden',
    alertValueGreaterZero: 'Bitte geben Sie einen Wert größer als Null ein.',
    alertLogin: 'Bitte melden Sie sich an, um fortzufahren.',
    alertSuccess: 'Bestellung gesendet! Sie erhalten {coins} Zephyr-Münzen (≈ {usd} USD).',
    alertError: 'Bestellung konnte nicht gesendet werden. Versuchen Sie es erneut.'
  },
  daily: {
    title: 'Tägliche Belohnung',
    subtitle: 'Lösen Sie heute Ihre Tagesbelohnung ein',
    rescue: 'Einlösen'
  },
  roulette: {
    headerTitle: 'Zephyr-Glücksrad',
    headerSubPoints: 'Preis des Glücksrads: 500 Zephyr-Punkte',
    headerSubBonus: 'Preis des Glücksrads: 1000 Zephyr-Bonus',
    user: 'Benutzer',
    pointsLabel: 'Punkte',
    bonusLabel: 'Bonus',
    title: 'Glücksrad',
    spinButtonAlt: 'Drehen',
    insufficientTitle: 'Unzureichendes Guthaben',
    insufficientMessage: 'Sie benötigen {cost} Zephyr-Punkte zum Drehen.',
    close: 'Schließen',
    congratsTitle: 'Herzlichen Glückwunsch!',
    congratsMessage:
      'Herzlichen Glückwunsch, Sie haben {quantity}x {name} gewonnen. Schauen Sie im Spiel-Shop nach und lösen Sie es ein.'
  }
}
